export const showAsAway = "TyP9he";
export default {showAsAway};